// Значки кнопок кривой. Свои, а не из общего набора: там нет ни глаза, ни
// корзины, а добавлять их в общий файл ради одного экрана значит трогать
// файл, который правят соседние сессии.
//
// Те же контуры, что у `ui/Icons.tsx`: 24×24, штрих 2, скругления.

type Props = { size?: number; width?: number };

function Svg({ size = 18, width = 2, children }: Props & { children: React.ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={width}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

/** Кривая видна. */
export function IconEye(props: Props) {
  return (
    <Svg {...props}>
      <path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z" />
      <circle cx="12" cy="12" r="2.8" />
    </Svg>
  );
}

/** Кривая скрыта: тот же глаз, перечёркнутый. */
export function IconEyeOff(props: Props) {
  return (
    <Svg {...props}>
      <path d="M4.5 7.3C2.9 8.9 2 12 2 12s3.6 6.5 10 6.5c1.6 0 3-.4 4.2-1" />
      <path d="M9.6 5.7A11 11 0 0 1 12 5.5c6.4 0 10 6.5 10 6.5s-1.2 2.2-3.4 4" />
      <path d="M10 10a2.8 2.8 0 0 0 4 4" />
      <path d="M3 3l18 18" />
    </Svg>
  );
}

/** Удалить кривую. */
export function IconTrash(props: Props) {
  return (
    <Svg {...props}>
      <path d="M4 7h16" />
      <path d="M9 7V4.8h6V7" />
      <path d="M6.5 7l.9 12.2h9.2L17.5 7" />
    </Svg>
  );
}
